import {
    getAllUsers,
    deleteUser,
    getUserHistory,
    getUserHistoryLT,
    getUserHistoryLT1,
    getUserHistoryLT3,
    getUserHistoryRO,
    getWithdrawalHistory,
    updateUserStatus as updateUserStatusApi,
    updateUserPassword as updateUserPasswordApi,
    updateUserData,
    createUser as createUserApi,
    getUserBalanceHistory
} from "../../helpers/apis";
import { toast } from "react-toastify";

// Action Types
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_USERS_SUCCESS = "GET_USERS_SUCCESS";
export const GET_USERS_FAIL = "GET_USERS_FAIL";
export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAIL = "DELETE_USER_FAIL";
export const GET_USER_HISTORY = "GET_USER_HISTORY";
export const GET_USER_HISTORY_SUCCESS = "GET_USER_HISTORY_SUCCESS";
export const GET_USER_HISTORY_FAIL = "GET_USER_HISTORY_FAIL";
export const SET_USER_FILTERS = "SET_USER_FILTERS";
export const CLEAR_USER_HISTORY = "CLEAR_USER_HISTORY";
export const BULK_DELETE_USERS = "BULK_DELETE_USERS";
export const BULK_DELETE_USERS_SUCCESS = "BULK_DELETE_USERS_SUCCESS";
export const BULK_DELETE_USERS_FAIL = "BULK_DELETE_USERS_FAIL";
export const SET_HISTORY_FILTERS = "SET_HISTORY_FILTERS";
export const UPDATE_USER_STATUS = "UPDATE_USER_STATUS";
export const UPDATE_USER_STATUS_SUCCESS = "UPDATE_USER_STATUS_SUCCESS";
export const UPDATE_USER_STATUS_FAIL = "UPDATE_USER_STATUS_FAIL";
export const ADD_USER_SUCCESS = "ADD_USER_SUCCESS";
export const ADD_USER_FAIL = "ADD_USER_FAIL";
export const ADD_USER = "ADD_USER";
export const UPDATE_USER = "UPDATE_USER";
export const GET_USER_BALANCE_HISTORY = "GET_USER_BALANCE_HISTORY";
export const GET_USER_BALANCE_HISTORY_SUCCESS = "GET_USER_BALANCE_HISTORY_SUCCESS";
export const GET_USER_BALANCE_HISTORY_FAIL = "GET_USER_BALANCE_HISTORY_FAIL";
export const UPDATE_USER_ONLINE_STATUS = "UPDATE_USER_ONLINE_STATUS";

// Get All Users
export const fetchAllUsers = (params = {}) => async (dispatch) => {
    try {
        dispatch({
            type: GET_ALL_USERS,
            payload: { loading: true }
        });

        const defaultParams = {
            page: 1,
            limit: params.isDownload ? undefined : 10, // No limit for export
            search: "",
            order: "desc",
            orderBy: "createdAt",
            ...params
        };

        const response = await getAllUsers(defaultParams);

        if (response.status === 1) {
            const usersData = response.data?.users || response.users || [];
            const gameType = params.gameType || 'lt';

            // Transform the data to match your table structure using the stats provided by backend
            const transformedUsers = usersData.map(user => {
                const stats = user.gameStatistics || {};
                const balance = user.balanceInfo || {};

                const baseUser = {
                    id: user._id,
                    _id: user._id,
                    acnumber: user.acnumber,
                    name: user.name || user.email?.split('@')[0] || 'User',
                    email: (user.email && user.email.includes('@')) ? user.email : '-',
                    phone: user.mobile || user.phone || '-',
                    isActive: !user.isDeleted,
                    status: !user.isDeleted ? 'active' : 'inactive',
                    createdAt: user.createdAt,
                    updatedAt: user.updatedAt,
                    coins: user.coins || balance.current || 0,
                    pendingWinningCoins: user.pendingWinningCoins || balance.pending || 0,
                    operatorName: user.createdBy?.username || 'Admin',
                    role: user.role || 'user', // Add role field with default 'user'
                    winMultiplier: user.winMultiplier || {},
                    gameAccess: user.gameAccess || { lt: true, lt1: true, ro: true },
                    gameStatistics: user.gameStatistics || {},
                    isOnline: user.isOnline || false,
                    activeGames: user.activeGames || []
                };

                // Use the batch statistics calculated by the backend
                if (gameType === 'lt1') {
                    return {
                        ...baseUser,
                        lt1TotalSpent: stats.totalCoinsBet || 0,
                        lt1TotalWon: stats.totalCoinsWon || 0,
                        lt1GamesPlayed: stats.totalGames || 0,
                        lt1GamesWon: stats.wins || 0
                    };
                } else if (gameType === 'ro') {
                    return {
                        ...baseUser,
                        roTotalSpent: stats.totalCoinsBet || 0,
                        roTotalWon: stats.totalCoinsWon || 0,
                        roGamesPlayed: stats.totalGames || 0,
                        roGamesWon: stats.wins || 0
                    };
                } else if (gameType === 'lt3') {
                    return {
                        ...baseUser,
                        lt3TotalSpent: stats.totalCoinsBet || 0,
                        lt3TotalWon: stats.totalCoinsWon || 0,
                        lt3GamesPlayed: stats.totalGames || 0,
                        lt3GamesWon: stats.wins || 0
                    };
                } else {
                    return {
                        ...baseUser,
                        ltTotalSpent: stats.totalCoinsBet || 0,
                        ltTotalWon: stats.totalCoinsWon || 0,
                        ltGamesPlayed: stats.totalGames || 0,
                        ltGamesWon: stats.wins || 0
                    };
                }
            });

            const totalCount = response.data?.pagination?.totalUsers || response.total || 0;

            dispatch({
                type: GET_USERS_SUCCESS,
                payload: {
                    users: transformedUsers,
                    total: totalCount,
                    currentPage: response.data?.pagination?.currentPage || defaultParams.page,
                    totalPages: response.data?.pagination?.totalPages || Math.ceil(totalCount / defaultParams.limit),
                    ...defaultParams
                }
            });

            return {
                success: true,
                data: response
            };
        } else {
            const errorMsg = response.message || "Failed to fetch users";
            dispatch({
                type: GET_USERS_FAIL,
                payload: errorMsg
            });

            toast.error(errorMsg);
            return {
                success: false,
                error: errorMsg
            };
        }
    } catch (error) {
        console.error("Fetch users error:", error);
        dispatch({
            type: GET_USERS_FAIL,
            payload: error.message || "Error loading users"
        });

        toast.error(error.message || "Error loading users");
        return {
            success: false,
            error: error.message
        };
    }
};

// Delete Single User
export const deleteSingleUser = (userId) => async (dispatch) => {
    try {
        dispatch({
            type: DELETE_USER,
            payload: { userId, loading: true }
        });

        const response = await deleteUser(userId);

        if (response.status === 1) {
            dispatch({
                type: DELETE_USER_SUCCESS,
                payload: { userId }
            });

            toast.success(response.message || "User deleted successfully");

            return {
                success: true,
                message: response.message
            };
        } else {
            dispatch({
                type: DELETE_USER_FAIL,
                payload: response.message || "Failed to delete user"
            });

            toast.error(response.message || "Failed to delete user");
            return {
                success: false,
                error: response.message
            };
        }
    } catch (error) {
        dispatch({
            type: DELETE_USER_FAIL,
            payload: error.message || "Error deleting user"
        });

        toast.error(error.message || "Error deleting user");
        return {
            success: false,
            error: error.message
        };
    }
};

// Get User History (Complete Activity)
export const fetchUserHistory = (userId, historyParams = {}) => async (dispatch) => {
    try {
        dispatch({
            type: GET_USER_HISTORY,
            payload: { userId, loading: true }
        });

        const defaultHistoryParams = {
            page: 1,
            limit: 10,
            type: 'all',
            gameType: 'lt',
            ...historyParams
        };

        const response = await getUserHistory(userId, defaultHistoryParams);

        if (response.status === 1) {
            dispatch({
                type: GET_USER_HISTORY_SUCCESS,
                payload: {
                    userId,
                    history: response.data, // Store the entire data object
                    pagination: {
                        currentPage: response.data?.pagination?.page || 1,
                        total: response.data?.pagination?.totalBids || response.data?.pagination?.total || 0,
                        totalPages: response.data?.pagination?.totalPages || 1
                    },
                    filters: defaultHistoryParams
                }
            });

            return {
                success: true,
                data: response.data
            };
        } else {
            dispatch({
                type: GET_USER_HISTORY_FAIL,
                payload: response.message || "Failed to fetch user history"
            });

            return {
                success: false,
                error: response.message
            };
        }
    } catch (error) {
        dispatch({
            type: GET_USER_HISTORY_FAIL,
            payload: error.message || "Error loading user history"
        });

        return {
            success: false,
            error: error.message
        };
    }
};

// Get User History (Complete Activity) - Lucky Target (LT) dedicated API
export const fetchUserHistoryLT = (userId, historyParams = {}) => async (dispatch) => {
    try {
        dispatch({
            type: GET_USER_HISTORY,
            payload: { userId, loading: true }
        });

        const defaultHistoryParams = {
            page: 1,
            limit: 10,
            type: "all",
            ...historyParams
        };

        const response = await getUserHistoryLT(userId, defaultHistoryParams);

        if (response.status === 1) {
            dispatch({
                type: GET_USER_HISTORY_SUCCESS,
                payload: {
                    userId,
                    history: response.data,
                    pagination: {
                        currentPage: response.data?.pagination?.page || 1,
                        total: response.data?.pagination?.totalBids || response.data?.pagination?.total || 0,
                        totalPages: response.data?.pagination?.totalPages || 1
                    },
                    filters: defaultHistoryParams
                }
            });

            return { success: true, data: response.data };
        }

        dispatch({
            type: GET_USER_HISTORY_FAIL,
            payload: response.message || "Failed to fetch user history"
        });
        return { success: false, error: response.message };
    } catch (error) {
        dispatch({
            type: GET_USER_HISTORY_FAIL,
            payload: error.message || "Error loading user history"
        });
        return { success: false, error: error.message };
    }
};

// Get User History (Complete Activity) - Lucky Target 1 (LT1) dedicated API
export const fetchUserHistoryLT1 = (userId, historyParams = {}) => async (dispatch) => {
    try {
        dispatch({
            type: GET_USER_HISTORY,
            payload: { userId, loading: true }
        });

        const defaultHistoryParams = {
            page: 1,
            limit: 10,
            type: "all",
            ...historyParams
        };

        const response = await getUserHistoryLT1(userId, defaultHistoryParams);

        if (response.status === 1) {
            dispatch({
                type: GET_USER_HISTORY_SUCCESS,
                payload: {
                    userId,
                    history: response.data,
                    pagination: {
                        currentPage: response.data?.pagination?.page || 1,
                        total: response.data?.pagination?.totalBids || response.data?.pagination?.total || 0,
                        totalPages: response.data?.pagination?.totalPages || 1
                    },
                    filters: defaultHistoryParams
                }
            });

            return { success: true, data: response.data };
        }

        dispatch({
            type: GET_USER_HISTORY_FAIL,
            payload: response.message || "Failed to fetch user history"
        });
        return { success: false, error: response.message };
    } catch (error) {
        dispatch({
            type: GET_USER_HISTORY_FAIL,
            payload: error.message || "Error loading user history"
        });
        return { success: false, error: error.message };
    }
};

// Get User History (Complete Activity) - American Roulette (RO) dedicated API
export const fetchUserHistoryRO = (userId, historyParams = {}) => async (dispatch) => {
    try {
        dispatch({
            type: GET_USER_HISTORY,
            payload: { userId, loading: true }
        });

        const defaultHistoryParams = {
            page: 1,
            limit: 10,
            type: "all",
            ...historyParams
        };

        const response = await getUserHistoryRO(userId, defaultHistoryParams);

        if (response.status === 1) {
            dispatch({
                type: GET_USER_HISTORY_SUCCESS,
                payload: {
                    userId,
                    history: response.data,
                    pagination: {
                        currentPage: response.data?.pagination?.page || 1,
                        total: response.data?.pagination?.totalBids || response.data?.pagination?.total || 0,
                        totalPages: response.data?.pagination?.totalPages || 1
                    },
                    filters: defaultHistoryParams
                }
            });

            return { success: true, data: response.data };
        }

        dispatch({
            type: GET_USER_HISTORY_FAIL,
            payload: response.message || "Failed to fetch user history"
        });
        return { success: false, error: response.message };
    } catch (error) {
        dispatch({
            type: GET_USER_HISTORY_FAIL,
            payload: error.message || "Error loading user history"
        });
        return { success: false, error: error.message };
    }
};

// Get User History (Complete Activity) - Lucky Target 3 (LT3) dedicated API
export const fetchUserHistoryLT3 = (userId, historyParams = {}) => async (dispatch) => {
    try {
        dispatch({
            type: GET_USER_HISTORY,
            payload: { userId, loading: true }
        });

        const defaultHistoryParams = {
            page: 1,
            limit: 10,
            type: "all",
            ...historyParams
        };

        const response = await getUserHistoryLT3(userId, defaultHistoryParams);

        if (response.status === 1) {
            dispatch({
                type: GET_USER_HISTORY_SUCCESS,
                payload: {
                    userId,
                    history: response.data,
                    pagination: {
                        currentPage: response.data?.pagination?.page || 1,
                        total: response.data?.pagination?.totalBids || response.data?.pagination?.total || 0,
                        totalPages: response.data?.pagination?.totalPages || 1
                    },
                    filters: defaultHistoryParams
                }
            });

            return { success: true, data: response.data };
        }

        dispatch({
            type: GET_USER_HISTORY_FAIL,
            payload: response.message || "Failed to fetch user history"
        });
        return { success: false, error: response.message };
    } catch (error) {
        dispatch({
            type: GET_USER_HISTORY_FAIL,
            payload: error.message || "Error loading user history"
        });
        return { success: false, error: error.message };
    }
};

// Set History Filters

export const setHistoryFilters = (userId, filters) => (dispatch) => {
    dispatch({
        type: SET_HISTORY_FILTERS,
        payload: { userId, filters }
    });

    return {
        success: true,
        filters
    };
};

// Set User Filters
export const setUserFilters = (filters) => (dispatch) => {
    dispatch({
        type: SET_USER_FILTERS,
        payload: filters
    });

    return {
        success: true,
        filters
    };
};

// Clear User History
export const clearUserHistory = () => (dispatch) => {
    dispatch({
        type: CLEAR_USER_HISTORY
    });

    return {
        success: true
    };
};

// Update User Password (used by admin for users)
export const updateUserPassword = (userId, data) => async (dispatch) => {
    try {
        const response = await updateUserPasswordApi(userId, data);

        if (response.success || response.status === 1) {
            toast.success("Password updated successfully");
            return { success: true };
        } else {
            toast.error(response.message || "Failed to update password");
            return { success: false, error: response.message };
        }
    } catch (error) {
        toast.error(error.message || "Error updating password");
        return { success: false, error: error.message };
    }
};

export const updateUserStatus = (userId, data) => async (dispatch) => {
    try {
        dispatch({
            type: UPDATE_USER_STATUS,
            payload: { loading: true }
        });

        const response = await updateUserStatusApi(userId, data);

        if (response.success || response.status === 1) {
            dispatch({
                type: UPDATE_USER_STATUS_SUCCESS,
                payload: { userId, data }
            });
            toast.success("User status updated successfully");
            return { success: true };
        } else {
            toast.error(response.message || "Failed to update status");
            dispatch({
                type: UPDATE_USER_STATUS_FAIL,
                payload: response.message
            });
            return { success: false, error: response.message };
        }
    } catch (error) {
        toast.error(error.message || "Error updating status");
        dispatch({
            type: UPDATE_USER_STATUS_FAIL,
            payload: error.message
        });
        return { success: false, error: error.message };
    }
};

export const addUser = (data) => async (dispatch) => {
    try {
        dispatch({
            type: ADD_USER,
            payload: { loading: true }
        });

        const response = await createUserApi(data);

        if (response.success || response.status === 1) {
            dispatch({
                type: ADD_USER_SUCCESS,
                payload: response.data
            });
            toast.success("User created successfully");
            return { success: true };
        } else {
            dispatch({
                type: ADD_USER_FAIL,
                payload: response.message
            });
            toast.error(response.message || "Failed to create user");
            return { success: false, error: response.message };
        }
    } catch (error) {
        dispatch({
            type: ADD_USER_FAIL,
            payload: error.message
        });
        toast.error(error.message || "Failed to create user");
        return { success: false, error: error.message };
    }
};

export const updateUserOperator = (userId, data) => async (dispatch) => {
    try {
        dispatch({
            type: UPDATE_USER,
            payload: { loading: true }
        });

        const response = await updateUserData(userId, data);

        if (response.success || response.status === 1) {
            toast.success("User updated successfully");
            return { success: true };
        } else {
            toast.error(response.message || "Failed to update user");
            return { success: false, error: response.message };
        }
    } catch (error) {
        toast.error(error.message || "Error updating user");
        return { success: false, error: error.message };
    }
};

// Get User Daily Balance History
export const fetchUserBalanceHistory = (userId, params = {}) => async (dispatch) => {
    try {
        dispatch({
            type: GET_USER_BALANCE_HISTORY,
            payload: { userId, loading: true }
        });

        const defaultParams = {
            page: 1,
            limit: 20,
            gameType: 'lt',
            ...params
        };

        const response = await getUserBalanceHistory(userId, defaultParams);

        if (response.status === 1) {
            dispatch({
                type: GET_USER_BALANCE_HISTORY_SUCCESS,
                payload: {
                    userId,
                    data: response.data
                }
            });
            return { success: true, data: response.data };
        }

        dispatch({
            type: GET_USER_BALANCE_HISTORY_FAIL,
            payload: response.message || "Failed to fetch balance history"
        });
        return { success: false, error: response.message };
    } catch (error) {
        dispatch({
            type: GET_USER_BALANCE_HISTORY_FAIL,
            payload: error.message || "Error loading balance history"
        });
        return { success: false, error: error.message };
    }
};
